module.exports = __webpack_public_path__ + "static/2-a85b076203d3baa4f13b9efa0da5c8aa.jpeg";